(function () {
	'use strict';

	var module = angular.module('uwAgenda.global');
	module.factory('ItemTableService', ['Item', '$filter', '$stateParams', 'HelperService', ItemTableServiceFn]);

	/* service to share date between controller and directives */
	function ItemTableServiceFn(Item, $filter, $stateParams, HelperService) {
		// service worker
		var service = {
			// array items
			items: [],
			// array of languages
			languages: [],
			// prototype with fields to translate
			prototype: {},
			// array of required fields
			requiredFields: [],

			// methods
			add: add,
			deactivate: deactivate,
			list: list,
			languageList: languageList,
			remove: remove,
			replace: replace,
			init: init,
			save: save,
			edit: edit,
			put: put,
			copy: copy,
			shortText: shortText,
			paginate: paginate,
			sort: sort
		};

		// new ItemTableService Instance
		service.Instance = function () {
			return new ItemTableServiceFn(Item, $filter, $stateParams, HelperService);
		};

		// status of table (validation)
		service.data = {
			ok: false, // are there any active rows ?
			editing: false, // is any row currently in edit-mode ?

			// pagination data
			pagination: {
				active: true, // is pagination needed -> set active here
				currentPage: 1,
				itemsPerPage: 15
			},

			// filter for show-all
			showAll: false, // default

			results: [], // result list (filtered and paginated)

			total: 0, // counter on items currently selected/filtered 

			sortFn: null, // sort function (optional)

			doLanguagePreparation: true // if false -> always all languages will be shown

		};

		//prepare language and callback
		service.doPrepareLanguages = function (searchValue) {
			// do preparation ?
			if (!service.data.doLanguagePreparation) {
				return;
			}

			// if function is available
			if (typeof service.prepareLanguages !== 'undefined' && service.prepareLanguages && angular.isFunction(service.prepareLanguages)) {
				// callback prepareLanguages function
				return service.prepareLanguages();
			}

			// native for - more performant
			for (var i = 0; i < service.languages.length; i++) {
				// first of all -> set to unused 
				service.languages[i].used = false;

				// look if language is in use
				var j = 0;
				var len = service.items.length;
				for (j = 0; j < len; j++) {
					// language in use and label active
					if (service.items[j].deleted === false && service.items[j].language && service.items[j].language.id === service.languages[i].id) {
						// set used
						service.languages[i].used = true;
					}
				} // for
			} // for
		};

		// do the validation
		service.doValidate = function () {
			// if function is available
			if (typeof service.validate !== 'undefined' && service.validate && angular.isFunction(service.validate)) {
				// callback validate function
				return service.validate();
			}

			// is at least one active in table 
			service.data.ok = service.items.some(function (item) {
				return item.deleted === false;
			});
		};

		return service;

		// init the service
		function init(entries, langs, entityPrototype, requiredPrototypeFields) {
			service.items = [];
			//clean and set
			service.data.ok = false;
			service.data.editing = false;
			service.data.pagination.currentPage = 1;
			// total items (counter)
			service.data.total = service.items.length;

			if (service.data.pagination.active === false)
			{
				service.data.pagination.itemsPerPage = 100000;
			}

			// set show-all-filter-checkbox
			if (typeof $stateParams.all !== 'undefined' && $stateParams.all !== null && $stateParams.all === true) {
				service.data.showAll = true;
			} //if
			else {
				service.data.showAll = false;
			} // else

			// protoype object
			service.prototype = entityPrototype;
			service.requiredFields = requiredPrototypeFields;

			if (entries && angular.isArray(entries)) {
				// disable pagination
				service.data.pagination.active = false;
				entries.forEach(function (item) {
					// new object put -> no pagination here 
					put(item);
				});
			} //if

			service.languages = [];
			if (langs) {
				langs.forEach(function (item) {
					// new object
					var lang = {
						used: false
					};
					angular.extend(lang, item);
					service.languages.push(lang);
				});
			} //if

			// prepare language list
			service.doPrepareLanguages();
			// validate 
			service.doValidate();
			//paginate
			paginate();
		}

		// put item to list
		function put(item, descending) {
			// new object
			var entry = new Item(service.prototype, service.requiredFields);
			entry.extend(item);
			entry.vmIndex = service.items.length;

			// push to array
			if (descending && descending === true) { service.items.unshift(entry); }
			else { service.items.push(entry); }

			// set correct index
			indexRefresh();
			// prepare language list
			service.doPrepareLanguages();
			// validate 
			service.doValidate();
			// paginate
			paginate();

			return entry;
		}

		

		// add new item
		function add() {
			// is another row in edit ?
			if (service.data.editing) {
				return;
			}

			// if language list is available
			if (service.languages !== null && service.languages.length > 0) {
				// are languages left ?
				var left = service.languages.some(function (item) {
					return item.used === false;
				});
				if (left === false) {
					return;
				} //if
			} // if

			// new object
			var entry = new Item(service.prototype, service.requiredFields);
			// editable
			entry.vmEditable = true;
			// new item
			entry.vmNew = true;

			// push to list
			service.items.unshift(entry);

			// set correct index
			indexRefresh();

			// edit mode ON
			service.data.editing = true;

			// paginate
			paginate();

			return entry;
		}

		// refresh vmIndex 
		function indexRefresh() {
			var i = 0;
			var len = service.items.length;
			for (i = 0; i < len; i++) {
				service.items[i].vmIndex = i;
			} //for
		} // indexRefresh

		// remove from array
		function remove(index) {
			// remove from array
			service.items.splice(index, 1);

			// refresh vmIndex in items
			indexRefresh();

			// edit mode OFF
			service.data.editing = false;

			// prepare language list
			service.doPrepareLanguages();
			// validate 
			service.doValidate();
			// paginate
			paginate();
		}

		// replace with item on index
		function replace(item, index) {
			if (index >= 0) {
				service.items[index] = item;
			} //if

			// edit mode OFF
			service.data.editing = false;

			// prepare language list
			service.doPrepareLanguages();
			// validate 
			service.doValidate();
			// paginate
			paginate();
		}

		// deactivate item
		// newly created items will be removed, existing items will be deactivated
		function deactivate(item, index) {
			item.deleted = true;
			item.vmEditable = false;

			// is item new ? -> then remove
			if (typeof item.id === 'undefined') {
				// remove
				remove(index);
			}
			else {
				// prepare language list
				service.doPrepareLanguages();
				// validate 
				service.doValidate();
			} // else

			// edit mode OFF
			service.data.editing = false;
		}

		// is currently a row in edit mode ?
		function inEditMode() {
			return service.items.some(function (item) {
				return item.vmEditable;
			});
		}

		// save item -> end editing
		function save(item) {
			item.vmEditable = false;
			item.vmNew = false;

			// edit mode OFF
			service.data.editing = false;

			// prepare language list
			service.doPrepareLanguages();
			// validate 
			service.doValidate();
		}

		// edit item
		function edit(item) {
			// is another row in edit ?
			if (service.data.editing) {
				return;
			} //if

			// make a copy for set back 
			var original = new Item(service.prototype, service.requiredFields);
			original.extend(item);
			// editing modus
			item.vmEditable = true;

			// edit mode ON
			service.data.editing = true;

			// prepare language list
			service.doPrepareLanguages();

			// return original for restoring
			return original;
		}

		// copy item
		function copy(item) {
			// is another row in edit ?
			if (service.data.editing) {
				return;
			} //if

			var copy = {};
			angular.copy(item, copy);
			// reset id
			copy.id = 0; // important


			// put to list and edit
			return edit(put(copy));
		} // copy

		// generate short text
		function shortText(value) {
			if (typeof value === 'string' || value instanceof String) {
				return value.substring(0, 8) + "...";
			}
			return "";
		}

		// return list
		function list() {
			return service.items;
		}

		// return language list
		function languageList() {
			// return languages, which are not used yet
			return $filter('filter')(service.languages, { 'used': false }, true);
		}

		// pagination -> calc new result items
		function paginate() {
			// is pagination active ?
			if (!service.data.pagination.active) {
				// assign items in case a new item has been added
				service.data.results = service.items;
			}
			else {
				// set new result list
				service.data.results = HelperService.paginate(service.items, service.data.pagination.currentPage, service.data.pagination.itemsPerPage);
			}
			service.data.total = service.items.length;
		} // paginate

		// sort items
		function sort() {
			if (service.items && service.data.sortFn !== null) {
				service.items.sort(service.data.sortFn);
				// refresh index
				indexRefresh();
				// paginate 
				paginate();
			} //if
		} // sort

	}
})();